var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-green box-shadow"},[_c('div',{staticClass:"cl"},[_c('div',{staticClass:"z"},[_vm._v("32")]),_c('div',{staticClass:"z"},[(_vm.title)?_c('div',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.subTitle)?_c('div',[_vm._v(_vm._s(_vm.subTitle))]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }